function swipers() {

    if ( $j('.testimonials-slider.col-3').length ) {
        $j('.testimonials-wrap.preload').removeClass('preload');
        if ( $j('.testimonials-slider.col-3').hasClass('rand') ) {
            let sliderContainer = document.querySelector('.testimonials-slider.col-3');
            shuffleSlides(sliderContainer);
        }
        var slider4 = tns({
            'container': '.testimonials-slider.col-3',
            'items': 1,
            "gutter": 20,
            'slideBy': 'page',
            'mouseDrag': true,
            'swipeAngle': false,
            'navPosition': 'bottom',
            'loop': true,
            'responsive': {
                '750': {
	                'items': 2,
	                "gutter": 20,
                },
                '1024': {
	                'items': 3,
	                "gutter": 20,
                }
            },
        });
        slider4.events.on('transitionEnd', function(){
            bLazy.revalidate();
        });
        slider4.events.on('newBreakpointStart', function(){
            bLazy.revalidate();
        });
    }
    if ( $j('.testimonials-slider.col-2').length ) {
        $j('.testimonials-wrap.preload').removeClass('preload');
        if ( $j('.testimonials-slider.col-2').hasClass('rand') ) {
            let sliderContainer = document.querySelector('.testimonials-slider.col-2');
            shuffleSlides(sliderContainer);
        }
        var slider5 = tns({
            'container': '.testimonials-slider.col-2',
            'items': 1,
            "gutter": 20,
            'slideBy': 'page',
            'mouseDrag': true,
            'swipeAngle': false,
            'navPosition': 'bottom',
            'loop': true,
            'responsive': {
                '750': {
                'items': 2,
                "gutter": 20,
                },
                '1000': {
                'items': 1,
                "gutter": 20,
                },
                '1200': {
                	'items': 2,
                    "gutter": 20,
                }
            },
        });
        slider5.events.on('transitionEnd', function(){
            bLazy.revalidate();
        });
        slider5.events.on('newBreakpointStart', function(){
            bLazy.revalidate();
        });
    }

    if ( $j('.videos-wrap').length ) {
        $j('.videos-wrap.preload').removeClass('preload');
        $j('.video-slide').hover(
            function() {
                if (window.matchMedia("(min-width: 980px)").matches) {
                    var video = $j(this).find('video').get(0);
                    if (video && video.readyState === 4) {
                        video.play(); // Play video on hover if it's loaded
                    }
                }
            },
            function() {
                if (window.matchMedia("(min-width: 981px)").matches) {
                    var video = $j(this).find('video').get(0);
                    if (video) {
                        //video.currentTime = 0;
                        video.pause(); // Pause video on leave
                    }
                }
            }
        );
        activeVideo();
    }

}

function activeVideo() {
    if (window.matchMedia("(max-width: 980px)").matches) {
        var activeVideo = $j('.videos-wrap .tns-slide-active:in-viewport:first').find('video').get(0);
        document.querySelectorAll('video').forEach(function (video) {
            if (video !== activeVideo) {
                video.pause();
            }
        });
        if (activeVideo && activeVideo.readyState === 4) {
            activeVideo.play();
        }
    }
}
